/* src/app/components/followers/followers.component.scss */
.box {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 20px;
}
img {
  cursor: pointer;
  width: 100%;
}
.card {
  font-family: "Quicksand", sans-serif;
}
/*# sourceMappingURL=followers.component.css.map */
